import { EnergyInfoBoxCopy } from 'ComponentLibrary/src/widgets/AssetInfoBoxes/EnergyInfoBox'
import { TFunction } from 'i18next'

export const getEnergyInfoBoxCopy = (tAssetDeviationAnalysis: TFunction, tCommon: TFunction): EnergyInfoBoxCopy => ({
    condensedTitle: tAssetDeviationAnalysis('energyInfoBox.condensedTitle'),
    spaciousSectionLabel: tAssetDeviationAnalysis('energyInfoBox.spaciousSectionLabel'),
    spaciousTitle: tAssetDeviationAnalysis('energyInfoBox.spaciousTitle'),
    energyEfficiencyClassLabel: tCommon('energyEfficiencyClass'),
    heatingTypeLabel: tCommon('heatingType'),
    primaryPowerConsumptionLabel: tAssetDeviationAnalysis('energyInfoBox.labels.primaryPowerConsumption'),
    primaryPowerConsumptionUnit: tAssetDeviationAnalysis('energyInfoBox.units.primaryPowerConsumption'),
    carbonDioxideEquivalentLabel: tCommon('carbonDioxideEquivalent'),
    carbonDioxideEquivalentUnit: tAssetDeviationAnalysis('energyInfoBox.units.carbonDioxideEquivalent'),
    fuelTypeLabels: {
        wood: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.wood'),
        gas: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.gas'),
        oil: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.oil'),
        environmental_soil: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.environmentalSoil'),
        environmental_air: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.environmentalAir'),
        environmental_solar: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.environmentalSolar'),
        electric_power: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.electricPower'),
        erdgas: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.erdgas'),
        fluessiggas: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.fluessiggas'),
        heizoel_el: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.heizoelEl'),
        strom: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.strom'),
        nah_fernwaerme: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.nahFernwaerme'),
        holzpellets: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.holzpellets'),
        holzhackschnitzel: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.holzhackschnitzel'),
        stueckholz: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.stueckholz'),
        waermepumpe: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.waermepumpe'),
        solarthermie: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.solarthermie'),
        geothermie: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.geothermie'),
        umweltwaerme: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.umweltwaerme'),
        hybrid_system: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.hybridSystem'),
        biogas_biomethan: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.biogasBiomethan'),
        steinkohle: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.steinkohle'),
        braunkohle: tAssetDeviationAnalysis('energyInfoBox.fuelTypeLabels.braunkohle'),
    },
})
